export default __webpack_public_path__ + "static/media/Snd2.eff5d2d9.mp3";